// styles
import '../scss/style.scss';
import 'swiper/swiper-bundle.css';

// components
import Header from './components/header';
import Banner from './components/banner';
import Cookies from './components/cookies';
import Modal from './components/modal';
import Map from './components/map';
import Certificates from './components/certificates';
import Video from './components/video';
import Hash from './components/hash';
import ContactForm from './components/contact-form';
import CareerForm from './components/career-form';

(() => {
    new Header('[data-header]');
    new Banner('[data-banner-slider]');
    new Cookies('[data-cookies]');
    new Modal('[data-modal]');
    new Map('#map');
    new Certificates('[data-certificates-slider]');
    new Video('[data-video]');
    new Hash('[data-hash]');
    new ContactForm('[data-contact-form]');
    new CareerForm('[data-career-form]');
})();
